import { Component, Input, OnInit } from '@angular/core';

import { BusinessSummary } from '../models/business-summary.model';
import {BusinessManagerService} from '../../shared/user/business-manager.service';
import { SubmitNewBusinessComponent } from '../submit-new-business/submit-new-business.component';
import { Airport } from '../models/airport.model';
import { MatDialog } from '@angular/material';


@Component({
  selector: 'app-business-listing',
  templateUrl: './business-listing.component.html',
  styleUrls: ['./business-listing.component.scss']
})
export class BusinessListingComponent implements OnInit {
  isFlightDeckAdmin = false;

  constructor( private businessManagerService: BusinessManagerService,
               private _matDialog: MatDialog) {
  }

  @Input() businesses: BusinessSummary[];
  @Input() fteAwardYear: string;
  @Input() airport: Airport;

  async ngOnInit() {
    this.isFlightDeckAdmin = await this.businessManagerService.isFlightDeckAdmin();
  }

  get sortedFBOs(): BusinessSummary[] {
    if (!this.isFlightDeckAdmin) {
      return this.businesses
        .filter(b => b.isFbo)
        .filter(fbo => !fbo.hideBusiness)
        .filter(fbo => !fbo.notApproved)
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
    }
    return this.businesses
      .filter(b => b.isFbo)
      .sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
  }

  get sortedFlightTraining(): BusinessSummary[] {
    if (!this.isFlightDeckAdmin) {
      return this.businesses
        .filter(b => b.flightTraining)
        .filter(fbo => !fbo.hideBusiness)
        .filter(fbo => !fbo.notApproved)
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
    }
    return this.businesses
      .filter(b => b.flightTraining)
      .sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
  }

  get sortedBusinesses(): BusinessSummary[] {
    if (!this.isFlightDeckAdmin) {
      return this.businesses
        .filter(b => !b.isFbo)
        .filter(b => !b.flightTraining)
        .filter(bus => !bus.hideBusiness)
        .filter(fbo => !fbo.notApproved)
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
    }
    return this.businesses
      .filter(b => !b.isFbo)
      .filter(b => !b.flightTraining)
      .sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
  }

  openSubmitNewBusinessDialog(facilityType: string): void {
    const dialogRef = this._matDialog.open(SubmitNewBusinessComponent, {
      disableClose: false,
      autoFocus: true,
      data: {
        airport: this.airport,
        facilityType: facilityType
      }
    });
  }
}
